<style>
  .slider-loading{
    left: 50%;
  }
</style>

<template>
 <div style="height:400px">
      <slider ref="slider" :options="options" @slide='slide' @tap='onTap' @init='onInit'>
          
          <slideritem v-for="(item,index) in someList" :key="index" :style="item.style">{{item.html}}</slideritem>
          
        <div slot="loading">loading... <img src="/assets/img/magnifying-glass.svg" alt=""></img></div>
      </slider>
 </div>
</template>
<script>
import { slider, slideritem } from 'vue-concise-slider'// import slider components
export default {
   data () {
      return {
        //Image list
        someList:[],
        //Sliding configuration [obj]
        options: {
          currentPage: 0,
          thresholdDistance:500,
          thresholdTime:100,
          autoplay:3000,
          loop:true,
          direction:'vertical',
          loopedSlides:1,
          slidesToScroll:1,
          timingFunction: 'ease',
          speed: 500,
        }
      }
    },
    components: {
      slider,
      slideritem
    },
    mounted () {
      let that = this
      setTimeout(function () {
        that.someList = [
          {
            
            style: {
              'background-image': 'url("/assets/img/post-cover-image-1.png")',
              'font-size':'120px',
              'font-family': "Roboto", 
              'color':'#751c00',
            },
            class: 'text-red',
          },
          {
            html: 'Fried Stuff',
            style: {
              'background-image': 'url("/assets/img/post-cover-image-2.png")',
              'font-size':'120px',
              'font-family': "Roboto", 
              'color':'#751c00',
            }
          }
        ]
      }, 1000)
    },
    methods: {
      // Listener event
      slide (data) {
        console.log(data)
      },
      onTap (data) {
        console.log(data)
      },
      onInit (data) {
        console.log(data)
      }
    }
}
</script>
